var exports = {
  "z": "x804f0401--7b4424--root",
};

module.exports = exports;
